import { useState } from 'react';
import { useDevice } from '../../hooks';
import { Avatar, Button } from '../ui';
import './InviteMore.css';
import { InviteModal } from './InviteModal';
import { AddReferralModal } from '.';
import { PublicUserModel } from '../../models';
import { getFriendlyPublicName } from '../../utils';

export function InviteMore(props: { signupCount: number; activeMembers: number; referralCode: string; username: string; referredBy: PublicUserModel | null }) {
   const { signupCount, activeMembers, referralCode, referredBy, username } = props;
   const { isMobile } = useDevice();
   const [inviteModalIsOpen, setInviteModalIsOpen] = useState(false);
   const [addReferralModalIsOpen, setAddReferralModalIsOpen] = useState(false);

   return (
      <div className={`flex flex-col gap-3 wrap ${isMobile ? 'flex-col' : ''}`}>
         <InviteModal
            referralCode={referralCode}
            isOpen={inviteModalIsOpen}
            username={username}
            onClose={() => setInviteModalIsOpen(false)}
         />
         <AddReferralModal
            isOpen={addReferralModalIsOpen}
            onClose={() => setAddReferralModalIsOpen(false)}
         />
         <div className="flex-2 flex items-center justify-between box bg-green-gradient-2 gap-4 wrap">
            {signupCount > 0 ? (
               <div className="flex items-center justify-start gap-4 flex-3">
                  <div className="flex flex-col items-center gap-1">
                     <h1 className="">{signupCount}</h1>
                     <span className="gray text-center nowrap">Sign ups</span>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                     <h1 className="">{activeMembers}</h1>
                     <span className="gray text-center nowrap">Active members</span>
                  </div>
               </div>
            ) : (
               <div className="flex flex-col gap-2">
                  <h2>Boost Your Earnings!</h2>
                  <span className="medium">Invite friends to join and earn more!</span>
               </div>
            )}
            <div className="flex wrap  justify-center gap-2">
               {!referredBy ? (
                  <Button
                     className="underline"
                     type="transparent"
                     title="Enter a referral code"
                     onClick={() => setAddReferralModalIsOpen(true)}
                  />
               ) : (
                  <div className="flex  gap-2 items-center px-2 box bg-gray">
                     <span className="small white">Referred by: </span>
                     <div
                        className="flex items-center"
                        style={{ gap: '2px' }}>
                        <Avatar
                           size={20}
                           imageUrl={referredBy.image ?? null}
                        />
                        <span className="medium">{getFriendlyPublicName(referredBy)}</span>
                     </div>
                  </div>
               )}
               <Button
                  title={`Invite ${signupCount > 0 ? 'More' : ''}`}
                  type="white-big"
                  children={
                     <img
                        src="/assets/icons/plus-icon-dark.svg"
                        alt=""
                        width={22}
                     />
                  }
                  onClick={() => setInviteModalIsOpen(true)}
               />
            </div>
         </div>
         <div className="flex gap-2 wrap">
            <div className="flex-1 box bg-gray flex items-center justify-between gap-2">
               <span>Earn 1 extra entry into a grand prize giveaway when you refer someone who creates an account.</span>
               <img
                  src="/assets/icons/ticket-icon.svg"
                  alt=""
                  width={60}
               />
            </div>
            <div className="flex-1 box bg-gray flex items-center justify-between gap-2">
               <span>Earn 1 digital golf ball for every referral who completes their profile. Digital golf balls will supercharge your earnings in app.</span>
               <img
                  src="/assets/icons/ball-icon.svg"
                  alt=""
                  width={70}
               />
            </div>
         </div>
      </div>
   );
}
